<div class="sdiv" style="margin-top: 20px;margin-right: 10px;">
    <label> Accrual</label>
    <input type="radio" value="A" name="type" checked (click)="selectTypeOfRedemption('A')">
    <label> Redemption</label>
    <input type="radio" value="R" name="type"  (click)="selectTypeOfRedemption('R')">
</div>
<div class="sdiv">
    <div class="btn clear-button button-margin dtn">
        <button class="btn btn-primary commonbutt" [disabled]="IsEmptyVal == false " (click)="searchData(2)"
            type="button">
            <em class="fa fa-search "></em>&nbsp;Search
        </button>
        <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyVal == false " type="button"
            (click)="searchData(1)">
            Download
        </button>
    </div>
</div>